import { memo } from 'react';
import { Fade, AccordionDetails } from '@material-ui/core';
import { DriverTableRow } from './DriverTableRow';
import { useBoardContext } from '../hooks/useBoardContext';
export const DriverTable = memo(
  ({
    classes,
    gigs: groupedGigs,
    boardId,
    showFirstAndLastName,
    textlineGroupUuid,
    children,
    bucketId
  }) => {
    const { bucketsExpandedState, setGroupExpandedState } = useBoardContext();

    const isGroupedGigExpanded = (index) => {
      return (
        bucketsExpandedState?.[bucketId]?.groups?.[index]?.isExpanded || false
      );
    };

    return (
      <AccordionDetails className={classes.panelDetails}>
        {groupedGigs?.length > 0 && (
          <Fade in>
            <div>
              {groupedGigs.map((groupedGig, index) => (
                <DriverTableRow
                  groupedGig={groupedGig}
                  key={index}
                  boardId={boardId}
                  showFirstAndLastName={showFirstAndLastName}
                  textlineGroupUuid={textlineGroupUuid}
                  bucketId={bucketId}
                  expanded={isGroupedGigExpanded(index)}
                  setGroupedGigExpandedState={(_, isExpanded) =>
                    setGroupExpandedState(bucketId, isExpanded, index)
                  }
                />
              ))}
              {children}
            </div>
          </Fade>
        )}
      </AccordionDetails>
    );
  }
);
